function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinylIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m825 281.81v226.31c42.75 8.7188 75 46.594 75 91.875s-32.25 83.156-75 91.875v226.31c167.06-9.75 300-148.87 300-318.19s-132.94-308.44-300-318.19z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 750,225 H 112.5 C 91.828,225 75,241.828 75,262.5 v 675 c 0,20.672 16.828,37.5 37.5,37.5 H 750 c 20.672,0 37.5,-16.828 37.5,-37.5 v -675 C 787.5,241.828 770.672,225 750,225 Z M 574.396,796.969 c -18.797,13.688 -43.312,15.469 -63.938,4.6406 l -79.219,-41.672 c -32.88567,12.48735 -71.30579,47.83996 -107.531,48.7032 -12.562,0 -24.984,-3.9375 -35.625,-11.672 -18.844,-13.688 -28.125,-36.469 -24.188,-59.391 l 15.141,-88.219 -64.078,-62.484 c -16.688,-16.266 -22.547,-40.125 -15.375,-62.25 7.2188,-22.125 25.969,-38.016 49.031,-41.344 l 88.594,-12.891 39.609,-80.25 c 10.312,-20.906 31.172,-33.844 54.469,-33.844 23.297,0 44.156,12.984 54.469,33.844 l 39.609,80.25 88.594,12.891 c 23.062,3.3281 41.812,19.219 49.031,41.344 7.1719,22.125 1.3125,45.984 -15.375,62.25 l -64.078,62.484 15.141,88.219 c 3.9375,22.969 -5.3438,45.703 -24.188,59.391 z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "m -543.84338,821.74774 a 55,55 0 0 1 -27.5,47.6314 55,55 0 0 1 -55.00001,0 55,55 0 0 1 -27.49999,-47.6314 h 55 z",
    transform: "rotate(-90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylIcon);
export default __webpack_public_path__ + "static/media/vinyl_icon.6b8bd7d37d8e2c62c35c0ab3d095d669.svg";
export { ForwardRef as ReactComponent };